import { Link, LinkProps } from '@mui/material';
import { getScannerName, getScannerTxLink } from 'shared/lib';

type ScannerLinkProps = {
  prefix?: string;
  txHash: string;
  chainId: number;
} & LinkProps;

export const TxScannerLink = ({ txHash, children, chainId, prefix, sx, ...props }: ScannerLinkProps) => {
  return (
    <Link
      className="accent"
      href={getScannerTxLink(chainId, txHash)}
      target="_blank"
      noWrap
      rel="noopener noreferrer"
      {...props}
      sx={{ textDecoration: 'none', ...sx }}
    >
      {prefix && (
        <>
          {prefix}
          &nbsp;
        </>
      )}
      {children ?? getScannerName(chainId)}
    </Link>
  );
};
